import { render, staticRenderFns } from "./AppSzukaj.vue?vue&type=template&id=e078649e&"
import script from "./AppSzukaj.vue?vue&type=script&lang=js&"
export * from "./AppSzukaj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports